import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@src/app/services/userService.service';
import { KBWMonitoringService } from '@src/app/services/logging.service';
import { UserModel, YMUserModel } from '@src/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import Utils from '@src/app/helpers/Utils';

@Component({
    selector: 'app-ym',
    templateUrl: './ym.component.html',
    styleUrls: ['./ym.component.css'],
    standalone: false
})
export class YmComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private monitoring: KBWMonitoringService,
    public translate: TranslateService
  ) { }

  userName:string;
  userSurname:string;
  documentNr:string;
  lang:string;
  trainingType:number;
  userId:string;
  qParams: any;

  ngOnInit(): void {
    this.route.queryParams.subscribe(param => {
      var queryParam = JSON.stringify(param).replace(/"([^"]+)":/g, function($0, $1)
      {
        return ('"' + $1.toLowerCase() + '":');
      });
      var qParam = JSON.parse(queryParam);
      // this.qParams = param;
      // this.userName = param['name'];
      // console.log(this.userName);
      // this.userSurname = param['surname'];
      // this.documentNr = param['docNr'];
      // this.trainingType = Number(this.qParams['trainingType']);
      //this.lang = param['lang'];
      // this.userId = param['userId'];

      var lng = this.resolveLang(qParam['lang']);
      if(!lng){
        lng = 'en-GB';
      }
      sessionStorage.setItem('flexusEnterUrl', window.location.href);
      sessionStorage.setItem('lang', lng);
      this.translate.use(lng);
      // sessionStorage.setItem('lang', lng);
      // this.translate.use(lng);
      sessionStorage.setItem('requestIdentifier', qParam['identifier']);

      const userDataModel: UserModel = {
        firstName: qParam['name'],
        lastName: qParam['surname'],
        documentNr: qParam['docnr'],
        trainingTypeId: +qParam['trainingtype'],
        customerIdentifier: qParam['customeridentifier'],
        customerIdentifierType: qParam['customeridentifiertype'],
        additionalDataValue: null,
        additionalDataKey: null,
        dataProcessAccept: true,
        regulationAccept: true,
        language: lng
      };

      this.monitoring.logEvent('ym_setdata_received', {
        customerIdentifier: qParam['customeridentifier'],
        customerIdentifierType: qParam['customeridentifiertype'],
        trainingType: qParam['trainingtype'],
        lang: lng
      });

      this.userService.sendDataFromYardManagement(userDataModel).subscribe((res) => {
        this.router.navigate(['/videotraining']);
      });
    });
  }
  
  resolveLang(lang: string): string {
      
      const langsDictSKPL = [
        {'pl': 'pl-PL'},
        {'de': 'de-DE'},
        {'en': 'en-GB'},
        {'ru': 'ru-RU'},
        {'ro': 'ro-RO'},
        {'hu': 'hu-HU'},
        {'bg': 'bg-BG'},
        {'hr': 'hr-HR'},
        {'uk': 'uk-UA'}
      ];
      const langsDictSKFR = [
        {'bg': 'bg-BG'},
        {'cs': 'cs-CZ'},
        {'es': 'es-ES'},
        {'et': 'et-EE'},
        {'fr': 'fr-FR'},
        {'hu': 'hu-HU'},
        {'it': 'it-IT'},
        {'lt': 'lt-LT'},
        {'pt': 'pt-PT'},
        {'ro': 'ro-RO'},
        {'sl': 'sl-SL'},
        {'pl': 'pl-PL'},
        {'de': 'de-DE'},
        {'en': 'en-GB'},
        {'ru': 'ru-RU'}
      ];
      let langObj = 'en-GB';
      const bookType = Utils.getBookType();
      try{
        // if(bookType === 'KBK' && lang.trim().toLowerCase() === 'uk') {
        //   return 'ru-RU';
        // }
        if(lang.length > 2){
          lang = lang.substring(0, 2);
        }
        let langTableFR = [];
        let langTablePL = [];
        langTableFR = langsDictSKFR;
        langTablePL = langsDictSKPL;
        if(bookType === 'KBK'){
          langObj = Object.values(langTablePL.filter(function(obj){ return obj[lang.trim().toLowerCase()] })[0])[0] as string;
        } 
        else if(bookType === 'SKFRDriver'){
          langObj = Object.values(langTableFR.filter(function(obj){ return obj[lang.trim().toLowerCase()] })[0])[0] as string;
        }
        else{
          return langObj;
        }
        //langObj = Object.values(langTable.filter(function(obj){ return obj[lang.trim().toLowerCase()] })[0])[0];
      }
      catch {
      }
      return langObj;
  }

}
